import { axiosInstance } from '@config/axios-instance-v2';
import { SouvenirBannerAddDto } from '@libs/dto/souvenir';

const url = `/admin/hotels`;
export const souvenirBannerService = {
  list(hotel_id: number, { page = '1', per_page = '10' }: { page: string; per_page: string }) {
    return axiosInstance.get(`${url}/${hotel_id}/souvenirs/settings/banners`, {
      params: { page, per_page },
    });
  },

  create(hotel_id, data: SouvenirBannerAddDto) {
    return axiosInstance.post(`${url}/${hotel_id}/souvenirs/settings/banners`, data);
  },
  update(hotel_id, id: string, data: SouvenirBannerAddDto) {
    return axiosInstance.put(`${url}/${hotel_id}/souvenirs/settings/banners/${id}`, data);
  },
  delete(hotel_id: number, id: string) {
    return axiosInstance.delete(`${url}/${hotel_id}/souvenirs/settings/banners/${id}`);
  },
};

export type SouvenirBannerService = typeof souvenirBannerService;
